import React, {
  ComponentType,
  Fragment,
  isValidElement,
  ReactNode,
} from "react";

export type IntersperseProps = {
  children: ReactNode | Array<ReactNode>;
  append?: boolean;
  prepend?: boolean;
  between?: () => ReactNode;
  Component?: ComponentType<{}>;
};

export default function Intersperse(props: IntersperseProps) {
  const { prepend = false, append = false, between, Component } = props;

  const children = Array.isArray(props.children)
    ? props.children
    : [props.children];

  const renderBetween = () => {
    if (Component) {
      return <Component />;
    } else if (between) {
      return between();
    } else {
      return <Fragment />;
    }
  };

  return (
    <Fragment>
      {children
        .filter((c) => c !== null && c !== undefined && !isEmptyFragment(c))
        .map((c, i) => {
          return (
            <Fragment key={i}>
              {i > 0 || prepend ? renderBetween() : null}
              {c}
              {i === children.length - 1 && append ? renderBetween() : null}
            </Fragment>
          );
        })}
    </Fragment>
  );
}

function isEmptyFragment(node: ReactNode) {
  return isValidElement(node) && node.type === Fragment && !node.props.children;
}
